import './cards.scss';

import classNames from 'classnames';
import React from 'react';
import Slider from 'react-slick';

import { useMediaQuery } from '../../hooks/useMediaQuery';
import { Card } from './card';
import * as styles from './cards.module.css';

const sliderSettings = {
	slidesToShow: 2,
	autoplay: false,
	unslick: true,
	responsive: [
		{
			breakpoint: 999,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: false,
				dots: true,
				speed: 200,
				adaptiveHeight: true,
				centerMode: false,
				unslick: false,
			},
		},
		{
			breakpoint: 799,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				dots: true,
				speed: 200,
				adaptiveHeight: true,
				centerMode: false,
				unslick: false,
			},
		},
	],
};

interface CardsProps {
	arrowPosition: any;
	backgroundColor: any;
	buttonColorTheme: any;
	buttonFillBorder: any;
	cardColor: any;
	cardPadding: any;
	cardTitleStyle: any;
	cards: {
		_id: string;
	}[];
	cardsPerRow: any;
	contentAlignment: any;
	contentOrder: any;
	fadeEffects: any;
	hasArrow: any;
	iconPosition: any;
	imageAspectRatio: any;
	kind: any;
	linkColor: any;
	textColor: any;
	tocLayout: any;
	twoCardColumnRatio: any;
	underlined: any;
	useSliderForMobile: any;
	verticalPadding: any;
}

export function Cards({
	arrowPosition,
	backgroundColor,
	buttonColorTheme,
	buttonFillBorder,
	cardColor,
	cardPadding,
	cardTitleStyle,
	cards,
	cardsPerRow,
	contentAlignment,
	contentOrder,
	fadeEffects,
	hasArrow,
	iconPosition,
	imageAspectRatio,
	kind,
	linkColor,
	textColor,
	tocLayout,
	twoCardColumnRatio,
	underlined,
	useSliderForMobile,
	verticalPadding,
}: CardsProps) {
	// hooks
	const isMobile = useMediaQuery('(max-width: 999px)');

	// content padding
	const modulePaddingTop = verticalPadding?.modulePaddingTop;
	const modulePaddingBottom = verticalPadding?.modulePaddingBottom;
	const lightBackgrounds = ['cbge', 'cw', 'csgr', 'cpgr'];

	// fade effects
	const fadeEffectType = fadeEffects?.fadeEffectType;

	return (
		<div
			className={classNames(
				backgroundColor && `b${backgroundColor}`,
				modulePaddingBottom,
				modulePaddingTop,
				styles.moduleContainer
			)}
		>
			<div
				className={classNames({
					[styles.gridContainer]: !(isMobile && useSliderForMobile),
					[styles.slickContainer]: isMobile && useSliderForMobile,
				})}
			>
				{isMobile && useSliderForMobile ? (
					<Slider
						{...sliderSettings}
						className={classNames(
							'cards-slider',
							lightBackgrounds.includes(backgroundColor) &&
								'dark-dots',
							'slick-list'
						)}
					>
						{cards?.map((card) => {
							const { _id } = card;

							return (
								<Card
									arrowPosition={arrowPosition}
									buttonColorTheme={buttonColorTheme}
									buttonFillBorder={buttonFillBorder}
									cardColor={cardColor}
									cardData={card}
									cardPadding={cardPadding}
									cardTitleStyle={cardTitleStyle}
									cardsPerRow={cardsPerRow}
									contentAlignment={contentAlignment}
									contentOrder={contentOrder}
									fadeEffects={
										!isMobile && fadeEffects
											? fadeEffects
											: null
									}
									hasArrow={hasArrow}
									iconPosition={iconPosition}
									imageAspectRatio={imageAspectRatio}
									isMobile={isMobile}
									key={_id}
									kind={kind}
									linkColor={linkColor}
									textColor={textColor}
									underlined={underlined}
								/>
							);
						})}
					</Slider>
				) : (
					<div
						className={classNames(
							cardsPerRow === 'twoCards' &&
								styles[twoCardColumnRatio],
							fadeEffectType,
							styles.cardsContainer,
							tocLayout === true && styles.tocSpanEightColumns
						)}
					>
						{cards?.map((card) => {
							const { _id } = card;

							return (
								<Card
									arrowPosition={arrowPosition}
									buttonColorTheme={buttonColorTheme}
									buttonFillBorder={buttonFillBorder}
									cardColor={cardColor}
									cardData={card}
									cardPadding={cardPadding}
									cardTitleStyle={cardTitleStyle}
									cardsPerRow={cardsPerRow}
									contentAlignment={contentAlignment}
									contentOrder={contentOrder}
									fadeEffects={fadeEffects}
									hasArrow={hasArrow}
									iconPosition={iconPosition}
									imageAspectRatio={imageAspectRatio}
									isMobile={isMobile}
									key={_id}
									kind={kind}
									linkColor={linkColor}
									textColor={textColor}
									underlined={underlined}
								/>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
}
